import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "chevron"]
  static values = { expanded: Boolean }

  connect() {
    if (this.expandedValue) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  toggle() {
    if (this.expandedValue) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.contentTarget.classList.remove('hidden')
    this.chevronTarget.classList.add('rotate-180')
    this.expandedValue = true
  }

  collapse() {
    this.contentTarget.classList.add('hidden')
    this.chevronTarget.classList.remove('rotate-180')
    this.expandedValue = false
  }
}